import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login, isLoading, error } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Determine where to redirect after login
    // If user was redirected from a protected page, `location.state.from` will have the path
    const from = location.state?.from?.pathname || "/developer/dashboard"; // Default to /developer/dashboard

    const handleSubmit = async (e) => {
        e.preventDefault();
        const success = await login(username, password);
        if (success) {
            // Redirect to the intended page or default admin dashboard page
            navigate(from, { replace: true });
        }
        // Error state is handled by useAuth and displayed below
    };

    // Basic styling matching the Contact page theme
    const primaryTextColor = "text-silver-light";
    const secondaryTextColor = "text-silver-medium";

    return (
        <div className="bg-black min-h-screen flex items-center justify-center font-sans p-4">
            <div className="bg-off-black rounded-lg p-8 border border-gray-800 w-full max-w-md shadow-xl">
                <h1 className={`text-3xl font-serif font-medium text-center mb-6 ${primaryTextColor}`}>
                    Developer Login
                </h1>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label
                            className={`block text-sm font-medium mb-1 ${secondaryTextColor}`}
                            htmlFor="username"
                        >
                            Username
                        </label>
                        <input
                            className={`bg-black border rounded-md w-full py-2 px-3 ${primaryTextColor} leading-tight focus:outline-none focus:ring-1 focus:ring-silver-light focus:border-transparent transition border-gray-700`}
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            autoComplete="username"
                        />
                    </div>

                    <div>
                        <label
                            className={`block text-sm font-medium mb-1 ${secondaryTextColor}`}
                            htmlFor="password"
                        >
                            Password
                        </label>
                        <input
                            className={`bg-black border rounded-md w-full py-2 px-3 ${primaryTextColor} leading-tight focus:outline-none focus:ring-1 focus:ring-silver-light focus:border-transparent transition border-gray-700`}
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>

                    {error && (
                        <p className="text-red-400 text-sm text-center">{error}</p>
                    )}

                    <div>
                        <button
                            className={`w-full bg-black border border-silver-medium hover:bg-silver-medium hover:text-black text-silver-light font-medium py-2 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-off-black focus:ring-silver-light transition duration-300 flex items-center justify-center ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <FaSpinner className="animate-spin mr-2" />
                            ) : null}
                            {isLoading ? 'Logging In...' : 'Login'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage; 